import React, { useState, useEffect } from 'react';
import * as d3 from 'd3';

const TreeVisualizer = () => {
  const [treeData, setTreeData] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [treeType, setTreeType] = useState('binary'); // Modes: binary, n-ary, etc.

  // Add a node (binary tree logic, you can extend this for n-ary trees)
  const addNode = () => {
    setTreeData([
      ...treeData,
      { id: treeData.length, value: inputValue, left: null, right: null },
    ]);
    setInputValue('');
  };

  // Delete a node (for simplicity, just removes the last node)
  const deleteNode = () => {
    setTreeData(treeData.slice(0, treeData.length - 1));
  };

  // Visualize the tree using D3
  const drawTree = () => {
    const width = 800;
    const height = 600;
    const margin = { top: 40, right: 120, bottom: 40, left: 120 };
  
    const svg = d3
      .select('#tree-container')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
  
    svg.selectAll('*').remove(); // Clear previous visualization
  
    // Create the root from the treeData
    const root = d3.hierarchy({ children: treeData });
  
    // Create a tree layout with a size for the layout of nodes
    const treeLayout = d3.tree().size([height - margin.top - margin.bottom, width - margin.left - margin.right]);
  
    // Apply the layout to the root
    treeLayout(root);
  
    // Update links between nodes
    const links = svg
      .selectAll('.link')
      .data(root.links(), d => d.source.data.value + '-' + d.target.data.value);
  
    links
      .enter()
      .append('path')
      .attr('class', 'link')
      .attr(
        'd',
        d =>
          'M' +
          d.source.y +
          ',' +
          d.source.x +
          'C' +
          d.source.y +
          ',' +
          (d.source.x + d.target.x) / 2 +
          ' ' +
          d.target.y +
          ',' +
          (d.source.x + d.target.x) / 2 +
          ' ' +
          d.target.y +
          ',' +
          d.target.x
      )
      .style('fill', 'none')
      .style('stroke', '#ccc')
      .style('stroke-width', 2);
  
    // Update nodes
    const nodes = svg
      .selectAll('.node')
      .data(root.descendants(), d => d.data.value);
  
    // Remove old nodes
    nodes.exit().remove();
  
    // Enter new nodes
    const newNodes = nodes
      .enter()
      .append('g')
      .attr('class', 'node')
      .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')');
  
    // Add circles for nodes
    newNodes
      .append('circle')
      .attr('r', 10)
      .style('fill', 'lightsteelblue')
      .style('stroke', 'black')
      .style('stroke-width', 2);
  
    // Add text to the nodes
    newNodes
      .append('text')
      .attr('dy', -15)
      .attr('text-anchor', 'middle')
      .text(d => d.data.value);
  
    // Update existing nodes
    nodes.attr('transform', d => 'translate(' + d.y + ',' + d.x + ')');
  
    // Update links
    svg
      .selectAll('.link')
      .data(root.links(), d => d.source.data.value + '-' + d.target.data.value)
      .attr(
        'd',
        d =>
          'M' +
          d.source.y +
          ',' +
          d.source.x +
          'C' +
          d.source.y +
          ',' +
          (d.source.x + d.target.x) / 2 +
          ' ' +
          d.target.y +
          ',' +
          (d.source.x + d.target.x) / 2 +
          ' ' +
          d.target.y +
          ',' +
          d.target.x
      );
  };
  
  
  useEffect(() => {
    drawTree();
  }, [treeData]);

  return (
    <div className="container">
      <h2>Tree Visualizer</h2>
      <svg id="tree-container"></svg>
      <div className="button-group">
        <button onClick={() => setTreeType('binary')}>Binary Tree</button>
        <button onClick={() => setTreeType('n-ary')}>N-ary Tree</button>
      </div>

      <div className="operation-section">
        <input
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          placeholder="Enter node value"
        />
        <button onClick={addNode}>Add Node</button>
        <button onClick={deleteNode}>Delete Node</button>
      </div>
    </div>
  );
};

export default TreeVisualizer;
